import { BASE_URL } from "./variables";

/**
 * API function to get business multipliers for a specific business
 * @param {string|number} businessId - Business Entity ID to get multipliers for
 */
export const getBusinessMultipliers = async (businessId) => {
  try {
    if (!businessId) {
      console.warn('No businessId provided to getBusinessMultipliers');
      return { data: [] };
    }

    const response = await fetch(`${BASE_URL}/get-business-multipliers?BusinessEntityID=${businessId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjE1MzAxMCwiYnVzaW5lc3NJZCI6MTA0NzAsIk1lbWJlcklEIjoxNDU3MTcsInVzZXJuYW1lIjoic2VjdXJlLmFkbWluIiwiZmlyc3ROYW1lIjoiU3VwcG9ydCIsImxhc3ROYW1lIjoiQW5rb3RhIiwiYXBpQWNjZXNzIjpmYWxzZSwiZXhwIjoyNTM0MDIyMTQ0MDB9.fJaUKmFT1cv_AP-FGX-I8tBArpzMD5DF9l3-zqHY6aU'
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching business multipliers:', error);
    throw error;
  }
};

export default getBusinessMultipliers;
